import { useLocation } from 'react-router-dom'
import { useAppStore } from '@shared/store'
import { SITE } from '@shared/config'
import { localeRoot, postLocaleFromPath, POST_LOCALE_LABELS } from '@shared/lib/post-locale'
import * as styles from './Footer.css'

export function Footer() {
  const isDarkMode = useAppStore((s) => s.isDarkMode)
  const locale = postLocaleFromPath(useLocation().pathname)
  const labels = POST_LOCALE_LABELS[locale]
  return (
    <footer className={styles.footer}>
      <div className={styles.footerLeft}>
        <span className={styles.brandRow}>
          <img
            src="/images/plantology_logo.png"
            alt="Plantology"
            className={styles.brandParentLogo}
            style={isDarkMode ? { filter: 'invert(1)' } : undefined}
          />
          <span className={styles.brandDivider} aria-hidden="true" />
          <img
            src="/images/logo_black.webp"
            alt={SITE.name}
            className={styles.footerLogoImg}
            style={isDarkMode ? { filter: 'invert(1)' } : undefined}
          />
        </span>
      </div>

      <div className={styles.footerRight}>
        <div className={styles.footerLinks}>
          <a href={localeRoot(locale)} className={styles.footerLink}>{labels.home}</a>
          <a href="/about" className={styles.footerLink}>{labels.about}</a>
          <a href="/affiliate-disclosure" className={styles.footerLink}>{labels.disclosure}</a>
          <a href="/privacy-policy" className={styles.footerLink}>{labels.privacy}</a>
        </div>
        <p className={styles.copyright}>
          &copy; {new Date().getFullYear()} {SITE.name}. All rights reserved.
        </p>
      </div>
    </footer>
  )
}
